import { NavItem } from './navItems';

export const checkCanUseRelativePath = (l1Item: NavItem) => {
  const l1ItemReactEnabled = l1Item.isReactEnabled;
  const l2AndL3ItemsReactEnabled = l1Item.items?.every((l2Item) => {
    if (l2Item.items) {
      return l2Item.items.every((item) => item.isReactEnabled);
    }
    return l2Item.isReactEnabled;
  });
  const useRelativePaths = l1ItemReactEnabled && l2AndL3ItemsReactEnabled;

  return Boolean(useRelativePaths);
};
